import { render, staticRenderFns } from "./addInvitationComponent.vue?vue&type=template&id=02e5711c&scoped=true&"
import script from "./addInvitationComponent.vue?vue&type=script&lang=js&"
export * from "./addInvitationComponent.vue?vue&type=script&lang=js&"
import style0 from "./addInvitationComponent.vue?vue&type=style&index=0&id=02e5711c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e5711c",
  null
  
)

export default component.exports